import { Button } from "./Button";

interface ErrorStateProps {
  title?: string | undefined;
  message: string;
  retryLabel?: string | undefined;
  onRetry?: (() => void) | undefined;
  className?: string | undefined;
}

export function ErrorState({
  title = "エラーが発生しました",
  message,
  retryLabel = "リトライ",
  onRetry,
  className,
}: ErrorStateProps): JSX.Element {
  return (
    <div className={cx("rounded-lg border border-danger bg-danger-bg p-5 text-center", className)}>
      <h2 className="text-base font-semibold text-danger">{title}</h2>
      <p className="mt-2 text-sm leading-6 text-text-secondary">{message}</p>
      {onRetry !== undefined && (
        <div className="mt-4">
          <Button variant="secondary" onClick={onRetry}>
            {retryLabel}
          </Button>
        </div>
      )}
    </div>
  );
}

function cx(...classes: Array<string | false | undefined>): string {
  return classes.filter(Boolean).join(" ");
}
